import React from "react";
import ReactDOM from "react-dom/client";
import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Wrapper from "./Components/Content/Wrapper";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/client/:ukey" element={<Wrapper />} />
      {/* <Route path="/client/login" element={<Login />} /> */}
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>
);
